// TODO DELOR-321 Move directory inside servicedesk when cleaning up the feature flag

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook, createSubscriber } from '@atlassian/react-sweet-state';
import type { Actions, State } from '../../types.tsx';
import Store from '../store/index.tsx';

export const ChannelsDialogSubscriber = createSubscriber<State, Actions>(Store, {
	displayName: 'ChannelsDialogSubscriber',
});

export const useChannelsDialog = createHook(Store);
